const DetailStyle = {
    Tab: "Tab",
    Inline: "Inline",
}

export default DetailStyle;